// Additional per-area editorial detail + external links (extends translations.js)
export const AREA_EXTRA = {
  interior: {
    external: null,
    story: {
      de: "Mit über 20 Jahren Erfahrung bei führenden Inneneinrichtern der Schweiz und als Pionier im E-Commerce verbinden wir handwerkliche Tradition mit digitaler Vordenkerschaft — für Räume, die ebenso durchdacht wie zeitlos sind.",
      en: "With over 20 years of experience alongside Switzerland's leading interior designers and as a pioneer in e-commerce, we unite craftsmanship with digital foresight — for spaces as considered as they are timeless.",
      fr: "Avec plus de 20 ans d'expérience auprès des principaux architectes d'intérieur de Suisse et en tant que pionnier du e-commerce, nous allions l'artisanat à la vision numérique — pour des espaces aussi réfléchis qu'intemporels.",
    },
  },
  fashion: {
    external: { url: "https://popstyle.ai/", name: "POPSTYLE" },
    story: {
      de: "Unsere Fashion-Welt lebt auf POPSTYLE — einer KI-gestützten Plattform, die persönlichen Stil neu denkt und Mode als individuellen Ausdruck erlebbar macht.",
      en: "Our fashion world lives on POPSTYLE — an AI-powered platform that reimagines personal style and makes fashion tangible as individual expression.",
      fr: "Notre univers mode vit sur POPSTYLE — une plateforme propulsée par l'IA qui repense le style personnel et fait de la mode une expression individuelle.",
    },
    cardDesc: {
      de: "POPSTYLE ist die KI-gestützte Plattform, die persönlichen Stil neu denkt: individuelle Outfit-Empfehlungen, kuratierte Looks und Mode als Ausdruck Ihrer Persönlichkeit – jederzeit und für jeden Anlass.",
      en: "POPSTYLE is the AI-powered platform that reimagines personal style: individual outfit recommendations, curated looks and fashion as an expression of your personality – anytime, for any occasion.",
      fr: "POPSTYLE est la plateforme propulsée par l'IA qui repense le style personnel : recommandations de tenues individuelles, looks curatés et la mode comme expression de votre personnalité – à tout moment, pour chaque occasion.",
    },
  },
  "real-estate": {
    external: null,
    story: {
      de: "Auf Mandatsbasis übernehmen wir die Vermarktung und Entwicklung ausgewählter Immobilienprojekte — diskret, strategisch und konsequent wertorientiert.",
      en: "On a mandate basis we take on the marketing and development of selected real estate projects — discreet, strategic and consistently value-driven.",
      fr: "Sur mandat, nous assurons la commercialisation et le développement de projets immobiliers sélectionnés — avec discrétion, stratégie et un sens constant de la valeur.",
    },
  },
  consulting: {
    external: null,
    story: {
      de: "Unser wichtigster Fokus: Verwaltungsrats-Mandate (VR) sowie die persönliche Projektbegleitung anspruchsvoller Vorhaben — von der ersten Idee bis zur konsequenten Umsetzung.",
      en: "Our primary focus: board of directors (VR) mandates and the personal guidance of demanding projects — from the first idea to consistent execution.",
      fr: "Notre priorité : les mandats de conseil d'administration (VR) ainsi que l'accompagnement personnel de projets exigeants — de la première idée à une réalisation rigoureuse.",
    },
  },
};

export const VISIT_LABEL = { de: "Website besuchen", en: "Visit website", fr: "Visiter le site" };
export const PARTNER_LABEL = { de: "Partner-Welt", en: "Partner world", fr: "Univers partenaire" };
export const WINE_EXTERNAL = "https://myowncuvee.com/";
